import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en";
import zh from "./zh";
import km from "./km";

Vue.use(VueI18n);

const locale = localStorage.getItem("lang") || "km"; // 默认高棉语

export default new VueI18n({
    locale,
    fallbackLocale: "en",
    messages: { en, zh, km }
});
